<template>
  <div id="swaychat-prechat-form-wrapper">
    <div id="swaychat_prechat_form" class="swaychat-row-main swaychat-fadeInUp"
    :style="{
      maxHeight: maxHeight + 'px'
      }"
    >
      <div class="swaychat-form">
        <h5>{{ getPreChatLabels.welcome }}</h5>
        <form novalidate @submit.prevent="save" ref="form" >
            <component v-for="item in getPreChatFields"
              v-if="item.visible"
              :label="item.placeholder || item.label"
              :name="item.name"
              :type="item.type"
              :options="item.options"
              :is="item.template+'FormComponent'"
              :error="form[item.name] ? form[item.name].error : null"
              :value="form[item.name] ? form[item.name].value : null"
              :ref="item.name"
              @input="value => { form[item.name].value = value }"
              @submit="save"
            >
            </component>
            <div class="swaychat-row">
                <button-form-component expand="true" primary="true" :label="getPreChatLabels.send"></button-form-component>
            </div>
        </form>
        <powered-by-component></powered-by-component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextareaFormComponent from './input/TextareaFormComponent.vue'
import InputFormComponent from './input/InputFormComponent.vue'
import SocialFormComponent from './input/SocialFormComponent.vue'
import SelectFormComponent from './input/SelectFormComponent.vue'
import ButtonFormComponent from './input/ButtonFormComponent.vue'
import PoweredByComponent from './PoweredByComponent.vue'

export default {
  created() {
    window.addEventListener('resize', this.setMaxHeight)
    this.setMaxHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.setMaxHeight)
  },
  mounted() {
    this.initData(this.getUser)
  },
  components: {
    TextareaFormComponent,
    InputFormComponent,
    SocialFormComponent,
    SelectFormComponent,
    ButtonFormComponent,
    PoweredByComponent
  },
  computed: {
    ...mapGetters([
      'getPreChatLabels',
      'getPreChatFields',
      'getPreChatRef',
      'getUser'
    ])
  },
  watch: {
    getUser(user) {
        this.initData(user)
    }
  },
  data() {
    return {
      maxHeight: 0,
      form: {
        name: {
          value: '',
          error: false
        },
        email: {
          value: '',
          error: false
        },
        phone: {
          value: '',
          error: false
        },
        message: {
          value: '',
          error: false
        },
        departments: {
          value: '',
          error: false
        }
      }
    }
  },
  methods: {
    initData(user) {
      if (user)
      for (var i in user)
        if (this.form[i] && !this.form[i].value)
          this.form[i].value = user[i]
    },
    setMaxHeight() {
      this.maxHeight = document.documentElement.clientHeight
      if (!window.isSwayChatPopout) this.maxHeight -= 128
    },
    validate(v, ref) {

      const userInput = v ? v.trim() : ''
      const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const phoneRE = /[0-9-+]+/

      let valid = true

      if ((ref.type && ref.type == 'email' && userInput && !emailRE.test(userInput))
        || (ref.type && ref.type == 'tel' && phoneRE.test(userInput) && userInput.replace(/[^0-9]+/g,'').length < 7)
        || (ref.required && userInput.length < 2)
      )
        valid = false

      return valid

    },
    save() {

      let errors = 0
      for (var i in this.form) {

        if (this.getPreChatRef[i] && !this.validate(this.form[i].value, this.getPreChatRef[i])) {
          this.form[i].error = true
          errors += 1
        } else {
          this.form[i].error = false
        }

      }

      if (errors) {
        this.$nextTick(function () {
          let f = document.querySelector('.swaychat-error')
          if (f) f.focus()
        })
      } else {
        //process form here
        let meta = {}

        for (var i in this.getUser) {
            meta[i] = (this.getPreChatRef[i] && this.getPreChatRef[i].visible) ? this.form[i].value : ''
        }

        let message = this.form.message.value.trim()
        let team = this.form.departments.value

        if (message)
          this.$store.dispatch('postMessage', message)

        if (team)
          this.$store.dispatch('setTeam', team)

        this.$store.dispatch('saveMeta', meta)

        if (message && meta.email)
          this.$store.dispatch('notifyByEmail',{ message, meta })

      }

    }
  }
}

</script>
